import * as ko from "knockout";

import { init, update } from "./editGridBinding";


/**
 * Registers the 'editgrid' knockout binding.
 */
export function registerEditGridBinding(): void {
    ko.bindingHandlers.editgrid = {
        init, update
    };
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/ko-editgrid/index.ts